import React from 'react';

import { ConnectNotificationBanner } from '@stripe/react-connect-js';

export interface NotificationsChangeEvent {
  total: number;
  actionRequired: number;
}

export interface NotificationBannerProps {
  onNotificationsChange?: (event: NotificationsChangeEvent) => void;
}

/**
 * Aviso (`notification-banner`, T4.4): pendências e intervenções de risco,
 * no topo de Recebimentos (T6.1). Só ocupa espaço quando o Stripe tem algo a
 * avisar — o próprio componente não renderiza nada sem notificação. Precisa
 * estar dentro de um `StripeConnectProvider`.
 */
export function NotificationBanner({ onNotificationsChange }: NotificationBannerProps) {
  return <ConnectNotificationBanner onNotificationsChange={onNotificationsChange} />;
}
